import React from 'react'
import { withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, Timestamp } from 'components';
import { Button, Container, Dimmer, Loader } from 'semantic-ui-react'

import { API } from 'services';
import { uTimestamp } from 'utils';

import { EnumExamenType, /*EnumConfigurationType*/ } from 'enums';

import moment from 'moment';

const EXAMENS_PER_PAGE = 10;

class PaneExamenList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      examens: [],
      examenCriteria: ''
    };

    this.handleExamenReload = this.handleExamenReload.bind(this);
    this.handleExamenSearch = this.handleExamenSearch.bind(this);
    this.handleExamenSelect = this.handleExamenSelect.bind(this);
  }

  componentDidMount() {
    this.handleExamenReload();
  }

  handleExamenSearch(criteria) {

    this.setState({
      examenCriteria: criteria
    });
  }

  handleExamenSelect(examen) {

    // Clinic mode
    if(this.props.match.path.startsWith('/clinics/')) {

      this.props.history.push(`/clinics/horses/examens/${examen.uuid}`);
    } else {

      this.props.history.push(`/examens/${examen.uuid}`);
    }
  }

  handleExamenReload() {
    this.setState({
      loading: true
    }, () => {

      API.get(`/horses/${this.props.horse.uuid}/examens`)
        .then((response) => {

          this.setState({
            examens: response.data,
            loading: false
          });

        })
        .catch(() => {

          this.setState({
            loading: false
          });

        })
    });
  }

  render() {

    const { examens } = this.state;

    let columns = [
      {
        id: 'type',
        header: 'Type',
        value: (examen) => EnumExamenType.litteral(examen.type, examen.anesthesia_member, examen.anesthesia_type, examen.anesthesia_location)
      },
      {
        id: 'timestamp',
        header: 'Date',
        value: (examen) => moment.unix(uTimestamp.unix(examen.timestamp_start)).format('DD/MM/YYYY HH:mm:ss'),
        render: (examen) => moment.unix(uTimestamp.unix(examen.timestamp_start)).format('DD/MM/YYYY [à] HH:mm:ss'),
        sort: (a, b) => {
          return uTimestamp.unix(a.timestamp_start) - uTimestamp.unix(b.timestamp_start);
        },
        fit: true
      },
      {
        id: 'duration',
        header: 'Durée',
        value: (examen) => uTimestamp.diff(examen.timestamp_start, examen.timestamp_stop),
        render: (examen) => <Timestamp icon={false} start={examen.timestamp_start} stop={examen.timestamp_stop} />,
        fit: true
      },
      // {
      //   id: 'configuration',
      //   header: 'Configuration',
      //   value: (examen) => EnumConfigurationType.name(examen.configuration),
      //   fit: true
      // }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Users */}
          <Section title="Examens" onSearch={this.handleExamenSearch} actions={[
            <Button circular icon="sync" onClick={this.handleExamenReload} key={0} />
          ]}>

            {examens.length > 0 ? (

              <React.Fragment>

                {/* Number of available examens */}
                <InfosBar mode="column">
                  <span>{examens.length > 1 ? `${examens.length} examens disponibles` : '1 examen disponible'}</span>
                </InfosBar>

                {/* examens list */}
                <Table columns={columns}
                  criteria={this.state.examenCriteria}
                  items={examens}
                  itemsPerPage={EXAMENS_PER_PAGE}
                  onSelect={this.handleExamenSelect}
                  messageEmpty="Aucun examen ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No examen available
              <InfosBar mode="row">
                <span>Aucun examen disponible</span>
              </InfosBar>

            )}

            <Dimmer active={this.state.loading} inverted>
              <Loader inverted>Chargement...</Loader>
            </Dimmer>

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(PaneExamenList);
